import Vue from 'vue'
import { translate } from 'rhg-vue-common'

export function formatPoints (points) {
  if (!points && points !== 0) return null
  return translate('hdNumPoints', points, points.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
}

Vue.mixin({
  methods: {
    formatPoints
  }
})
